import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { UserManager, UserManagerSettings, User } from 'oidc-client';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/pixeltrade/services/base.service';
import { UserLogin } from 'src/app/pixeltrade/models/user-login.model';
import { store } from 'src/app/store';


@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseService {


  private _authNavStatusSource = new BehaviorSubject<boolean>(false);
  authNavStatus$ = this._authNavStatusSource.asObservable();

  private manager = new UserManager(getClientSettings());
  private user: User | null;

  constructor(public http: HttpClient) {

    super(http);
    this.manager.getUser().then(user => {
      this.user = user;
      this._authNavStatusSource.next(this.isAuthenticated());
    });
  }

  login() {
    return this.manager.signinRedirect();
  }

  async completeAuthentication() {
    this.user = await this.manager.signinRedirectCallback();
    this._authNavStatusSource.next(this.isAuthenticated());
  }

  register(userRegistration: any) {
    return this.post<any>(environment.authApiURI + '/account/register', userRegistration).pipe(catchError(this.handleError));
  }

  isAuthenticated(): boolean {
    return this.user != null && !this.user.expired;
  }

  // isAuthenticated2(): boolean {

  //   const allState = store.getState();
  //   this.user = allState.user;
  //   return this.user != null && !this.user.expired;
  // }

  // updateFromState() {
  //   store.subscribe(() => {
  //     const allState = store.getState();
  //     
  //   });
  // }

  getRole(): string {
    return this.user.profile['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  }

  get authorizationHeaderValue(): string {
    if(this.user){
      return `${this.user.token_type} ${this.user.access_token}`;
    }
  }

  get getToken(): string {
    return this.user.access_token;
  }

  get name(): string {
    return this.user != null ? this.user.profile.name : '';
  }

  get email(): string {
    return this.user != null ? this.user.profile.email : '';
  }

  async signout() {
    await this.manager.signoutRedirect();
  }
}

export function getClientSettings(): UserManagerSettings {
  return {
    authority: environment.authApiURI,
    client_id: environment.client_id,
    redirect_uri: `${environment.appURI}${environment.authCallback}`,
    post_logout_redirect_uri: `${environment.appURI}${environment.post_logout_redirect_uri}`,
    response_type: environment.response_type,
    scope: environment.scope,
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: `${environment.appURI}${environment.silent_redirect_uri}`
  };
}
